"use strict";
/**
 * AI Hub Library Constants
 *
 * Centralized constants used across AI Hub library components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_TEMPLATES = exports.CHANGE_HISTORY_SOURCES = exports.parseEdgeWeight = exports.getEdgeWeightShortLabel = exports.DEFAULT_EDGE_WEIGHT = exports.EDGE_WEIGHT_SHORT_LABELS = exports.EDGE_WEIGHT_LABELS = exports.EDGE_WEIGHT_VALUES = exports.STRATEGY_BUILDER_COMPACT_LAYOUT = exports.STRATEGY_BUILDER_LAYOUT_BREAKPOINT = exports.DEFAULT_GRAPH_HEIGHT = exports.VISUALIZATION_DEBOUNCE_DELAY = void 0;
/**
 * Default debounce delay for visualization updates (in milliseconds)
 */
exports.VISUALIZATION_DEBOUNCE_DELAY = 600;
/**
 * Default graph height for visualizations
 */
exports.DEFAULT_GRAPH_HEIGHT = '700px';
/**
 * Breakpoint below which the strategy builder uses its compact layout
 */
exports.STRATEGY_BUILDER_LAYOUT_BREAKPOINT = 1280;
/**
 * Compact layout used by the strategy builder on narrower viewports
 */
exports.STRATEGY_BUILDER_COMPACT_LAYOUT = 'graph-first';
/**
 * Edge weight label-to-value mapping
 */
exports.EDGE_WEIGHT_VALUES = {
    low: 0.1,
    medium: 0.3,
    high: 0.5,
    'very-high': 0.8,
};
/**
 * Edge weight display labels
 */
exports.EDGE_WEIGHT_LABELS = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    'very-high': 'Very High',
};
/**
 * Edge weight short labels (for graph/node labels)
 */
exports.EDGE_WEIGHT_SHORT_LABELS = {
    low: 'Low',
    medium: 'Med',
    high: 'High',
    'very-high': 'V.High',
};
/**
 * Default edge weight for new connections
 */
exports.DEFAULT_EDGE_WEIGHT = 'medium';
/**
 * Convert edge weight type to short label (for graph nodes)
 * @param {EdgeWeightType} type - Edge weight type
 * @returns {string} Short display label
 */
exports.getEdgeWeightShortLabel = function (type) {
    return exports.EDGE_WEIGHT_SHORT_LABELS[type];
};
/**
 * Parse edge weight from persisted strategy data.
 * @param {string} value - Edge weight value from the API
 * @returns {EdgeWeightType} Edge weight type
 */
exports.parseEdgeWeight = function (value) {
    if (['low', 'medium', 'high', 'very-high'].includes(value)) {
        return value;
    }
    return exports.DEFAULT_EDGE_WEIGHT;
};
/**
 * Change history sources
 */
exports.CHANGE_HISTORY_SOURCES = {
    STRATEGIES: 'strategies',
    STRATEGY_BUILDER: 'strategy-builder',
};
/**
 * Message templates
 */
exports.MESSAGE_TEMPLATES = {
    SAVE_SUCCESS: 'Changes saved successfully!',
    SAVE_ERROR: 'An unexpected error occurred while saving. Please try again.',
    LOAD_ERROR: 'Failed to load data. Please refresh the page.',
    CONFLICT_ERROR: 'This configuration was modified by another user. Please refresh and try again.',
    VALIDATION_ERROR: 'Please fix validation errors before saving.',
};
